export default __webpack_public_path__ + "static/media/Group 10143.17026602.svg";